/* Wave Konfigurátor — jadro pre SAMOSTATNÉ diely (tienidlo / podstavec).
   Odvodené z wave-core.js. Režim určuje window.WAVE_CFG.mode ('shade' | 'base').
   - 'shade': predáva sa IBA vrch (tienidlo). Cena = cena vrchu × markup.
   - 'base' : predáva sa IBA podstavec + automatická krytka. Cena = (podstavec+krytka) × markup.
   Krytka sa nikdy nepredáva samostatne — je vždy súčasťou podstavca.
   Doplnky (napájanie/žiarovka/express) a bundle zľava ostávajú ako pri celej lampe. */
window.WavePartCore = (function () {
  var ORIGIN = 'https://kroma3d.app';
  var CFG = window.WAVE_CFG || {};
  var MODE = CFG.mode || 'shade';        // 'shade' | 'base'
  var MARKUP = +CFG.markup || 1;         // prirážka na telo dielu (samostatný predaj)

  /* ---- Katalóg ---- */
  function topById(id) { return WAVE.tops.find(function (t) { return t.id === id; }) || WAVE.tops[0]; }
  function baseById(id) { return WAVE.bases.find(function (b) { return b.id === id; }) || WAVE.bases[0]; }
  function capOfBase(baseId) { var b = baseById(baseId); return WAVE.caps[b.cap]; }
  function priceOfItem(it) { return WAVE.price(it.g, it.min); }
  function topPrice(lamp) { return priceOfItem(topById(lamp.top)); }
  function baseUnitPrice(lamp) {
    var b = baseById(lamp.base);
    var cap = WAVE.caps[b.cap];
    return priceOfItem(b) + (cap ? priceOfItem(cap) : 0);
  }

  /* ---- Stav jedného dielu ---- */
  function newLamp() {
    return {
      top: CFG.defaultTop || 'diamond',
      base: CFG.defaultBase || 'rebrovany1',
      topMatte: false,
      baseMatte: false,
      cap: { colorHex: '#FFFFFF', colorName: 'Biela' },
      topColor: { hex: '#FFFFFF', name: 'Biela' },
      baseColor: { hex: '#E8DBB7', name: 'Piesková' },
      power: 'none',
      socketType: 'E27',
      bulb: { on: false, socket: 'E27', temp: 'warm' },
      express: false,
      qty: 1,
      kromaSel: null
    };
  }

  /* ---- Viewer (per-mode URL) ---- */
  function mountViewer(iframe, forceMobile) {
    iframe.src = CFG.viewerUrl || WAVE.viewerUrl;
    function sendSize() {
      var wrap = iframe.parentElement; if (!wrap) return;
      var w = wrap.offsetWidth || wrap.clientWidth, h = wrap.offsetHeight || wrap.clientHeight;
      try {
        if (forceMobile) {
          iframe.contentWindow.postMessage({ type: 'kumo:forceMobile' }, ORIGIN);
          iframe.contentWindow.postMessage({ type: 'wave:forceMobile' }, ORIGIN);
        } else {
          iframe.contentWindow.postMessage({ type: 'kumo:forceDesktop' }, ORIGIN);
          iframe.contentWindow.postMessage({ type: 'wave:forceDesktop' }, ORIGIN);
        }
        iframe.contentWindow.postMessage({ type: 'kumo:resize', width: w, height: h }, ORIGIN);
        iframe.contentWindow.postMessage({ type: 'wave:resize', width: w, height: h }, ORIGIN);
      } catch (e) {}
    }
    iframe.addEventListener('load', function () { setTimeout(sendSize, 200); setTimeout(sendSize, 900); });
    window.addEventListener('resize', sendSize);
    return sendSize;
  }

  /* ---- Fullscreen ---- */
  function mountFullscreen(opts) {
    var btn = opts.btn, preview = opts.preview, label = opts.label, icon = opts.icon, onChange = opts.onChange;
    if (!btn || !preview) return;
    function setFs(on) {
      preview.classList.toggle('is-fullscreen', on);
      document.body.classList.toggle('wave-fs-locked', on);
      if (label) label.textContent = on ? 'Zavrieť' : 'Zväčšiť';
      if (icon) icon.textContent = on ? '×' : '';
      btn.setAttribute('aria-label', on ? 'Zavrieť konfigurátor' : 'Zväčšiť konfigurátor');
      if (onChange) setTimeout(onChange, 60);
    }
    btn.addEventListener('click', function () { setFs(!preview.classList.contains('is-fullscreen')); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && preview.classList.contains('is-fullscreen')) setFs(false);
    });
  }

  /* ---- Mapovanie kroma3d model -> nas WAVE id ---- */
  function deburr(s) { return (s == null ? '' : '' + s).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim(); }
  var TOP_MODEL_MAP = { diamond: 'diamond', canopy: 'canopy', flow: 'flow', rombus: 'rombus', tessera: 'tessera', spiral: 'torsion' };
  var BASE_MODEL_MAP = { 'rebrovany': 'rebrovany1', 'rebrovany ii': 'rebrovany2', 'led stand': 'ledstand', 'mini led': 'miniled', 'canopy stand': 'canopy' };

  function colorNameFrom(colorId, colorHex) {
    if (colorHex) {
      var hx = colorHex.toLowerCase();
      var hit = WAVE.colors.find(function (c) { return c.hex.toLowerCase() === hx; });
      if (hit) return hit.name;
    }
    if (colorId) return ('' + colorId).split('-').map(function (w) { return w ? w.charAt(0).toUpperCase() + w.slice(1) : w; }).join(' ');
    return colorHex || '';
  }

  /* ---- Počúvaj výber z 3D ---- */
  function listenSelection(getActiveLamp, onUpdate) {
    window.addEventListener('message', function (ev) {
      if (!ev || !ev.data) return;
      var t = ev.data.type;
      if (t !== 'kroma3d:selectionchange' && t !== 'wave:selectionchange') return;
      if (!Array.isArray(ev.data.selections)) return;
      try { var host = new URL(ev.origin).hostname; if (host && !/(^|\.)kroma3d\.app$/i.test(host)) return; } catch (e) { return; }
      var lamp = getActiveLamp(); if (!lamp) return;
      var changed = false;
      ev.data.selections.forEach(function (sel) {
        if (!sel || typeof sel !== 'object') return;
        var part = ('' + (sel.objectId || '')).toLowerCase();
        var key = deburr(sel.model);
        var cName = colorNameFrom(sel.colorId, sel.colorHex);
        if (part === 'lampshade') {
          if (TOP_MODEL_MAP[key]) { lamp.top = TOP_MODEL_MAP[key]; changed = true; }
          if (sel.colorHex) { lamp.topColor = { hex: sel.colorHex, name: cName }; changed = true; }
        } else if (part === 'base') {
          if (BASE_MODEL_MAP[key]) { lamp.base = BASE_MODEL_MAP[key]; changed = true; }
          if (sel.colorHex) { lamp.baseColor = { hex: sel.colorHex, name: cName }; changed = true; }
        } else if (part === 'cap') {
          if (sel.colorHex) { lamp.cap.colorHex = sel.colorHex; lamp.cap.colorName = cName; changed = true; }
        }
      });
      lamp.kromaSel = ev.data.selections.map(function (s) {
        return { objectId: s.objectId, model: s.model, variant: s.variant, subvariant: s.subvariant, colorPalette: s.colorPalette, colorId: s.colorId, colorHex: s.colorHex };
      });
      if (changed && onUpdate) onUpdate();
    });
  }

  /* ---- Cena ---- */
  function powerAdd(lamp) { var p = WAVE.power.find(function (x) { return x.id === lamp.power; }); return p ? p.add : 0; }
  function bulbAdd(lamp) { return lamp.bulb && lamp.bulb.on ? WAVE.bulb.add : 0; }
  function matteAdd(lamp) {
    if (MODE === 'shade') return lamp.topMatte ? WAVE.matteSurcharge : 0;
    if (MODE === 'base')  return lamp.baseMatte ? WAVE.matteSurcharge : 0;
    return (lamp.topMatte ? WAVE.matteSurcharge : 0) + (lamp.baseMatte ? WAVE.matteSurcharge : 0);
  }
  function baseHasLight(lamp) { return !!baseById(lamp.base).light; }

  /* telo dielu (s prirážkou za samostatný predaj) */
  function bodyPrice(lamp) {
    if (MODE === 'base') return baseUnitPrice(lamp) * MARKUP;  // podstavec + krytka
    return topPrice(lamp) * MARKUP;                            // tienidlo (shade)
  }
  function calcLamp(lamp) {
    return bodyPrice(lamp) + matteAdd(lamp) + powerAdd(lamp) + bulbAdd(lamp) + (lamp.express ? WAVE.express : 0);
  }

  /* ---- Rozmery a hmotnosť (len pre daný diel) ---- */
  function lampWeight(lamp) {
    var t = topById(lamp.top), b = baseById(lamp.base), cap = capOfBase(lamp.base);
    var g = MODE === 'base' ? (b.g + (cap ? cap.g : 0)) : t.g;
    return Math.round(g / 50) * 50;
  }
  function lampHeight(lamp) {
    var t = topById(lamp.top), b = baseById(lamp.base);
    return MODE === 'base' ? (b.h || 0) : (t.h || 0);
  }

  /* ---- Termín dodania ---- */
  var DAYS_GEN = ['nedele', 'pondelka', 'utorka', 'stredy', 'štvrtka', 'piatka', 'soboty'];
  function addBusinessDays(date, n) {
    var d = new Date(date.getTime()), added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }
  function deliveryInfo(express) {
    var cfg = WAVE.delivery || {};
    if (express) {
      var d = addBusinessDays(new Date(), cfg.expressWorkDays || 1);
      return { express: true, label: 'do ' + DAYS_GEN[d.getDay()] + ' ' + d.getDate() + '. ' + (d.getMonth() + 1) + '.' };
    }
    var min = cfg.minDays || 3, max = cfg.maxDays || 7;
    var start = addBusinessDays(new Date(), min);
    var end = addBusinessDays(new Date(), max);
    var fmt = function (x) { return x.getDate() + '.' + (x.getMonth() + 1) + '.'; };
    return { express: false, label: 'medzi ' + fmt(start) + ' a ' + fmt(end) };
  }

  /* ---- Zdieľanie konfigurácie cez URL ---- */
  function encodeConfig(items, activeIdx) {
    var arr = items.map(function (l) {
      return [l.top, l.base, l.cap.colorHex, l.cap.colorName, l.topMatte ? 1 : 0, l.baseMatte ? 1 : 0,
        l.power, l.socketType, l.bulb.on ? 1 : 0, l.bulb.socket, l.bulb.temp, l.express ? 1 : 0, l.qty || 1,
        (l.topColor && l.topColor.hex) || '', (l.topColor && l.topColor.name) || '',
        (l.baseColor && l.baseColor.hex) || '', (l.baseColor && l.baseColor.name) || '',
        (l.kromaSel || null)];
    });
    return encodeURIComponent(JSON.stringify({ a: activeIdx, l: arr }));
  }
  function decodeConfig(str) {
    try {
      var o = JSON.parse(decodeURIComponent(str));
      if (!o || !Array.isArray(o.l) || !o.l.length) return null;
      var items = o.l.slice(0, WAVE.maxLamps).map(function (a) {
        var lamp = newLamp();
        if (a[0]) lamp.top = a[0];
        if (a[1]) lamp.base = a[1];
        if (a[2]) lamp.cap.colorHex = a[2];
        if (a[3]) lamp.cap.colorName = a[3];
        lamp.topMatte = !!a[4]; lamp.baseMatte = !!a[5];
        lamp.power = a[6] || 'none'; lamp.socketType = a[7] || 'E27';
        lamp.bulb.on = !!a[8]; lamp.bulb.socket = a[9] || 'E27'; lamp.bulb.temp = a[10] || 'warm';
        lamp.express = !!a[11]; lamp.qty = a[12] || 1;
        if (a[13]) lamp.topColor = { hex: a[13], name: a[14] || '' };
        if (a[15]) lamp.baseColor = { hex: a[15], name: a[16] || '' };
        if (Array.isArray(a[17])) lamp.kromaSel = a[17];
        return lamp;
      });
      return { items: items, activeIdx: Math.max(0, Math.min(o.a || 0, items.length - 1)) };
    } catch (e) { return null; }
  }

  function lampCount(items) { return items.reduce(function (s, l) { return s + (l.qty || 1); }, 0); }
  function bundleRate(items) {
    var n = lampCount(items), arr = WAVE.bundle || [];
    for (var i = 0; i < arr.length; i++) { if (n >= arr[i].min) return arr[i].rate; }
    return 0;
  }
  function grandSubtotal(items) {
    return items.reduce(function (s, l) { return s + calcLamp(l) * (l.qty || 1); }, 0);
  }
  function grandTotal(items) { return grandSubtotal(items) * (1 - bundleRate(items)); }

  /* ---- Počkaj na kroma3d:ready ---- */
  function onViewerReady(iframe, cb) {
    var readySeen = false;
    function run(src) {
      if (/[?&]kromadebug=1/.test(location.search)) { try { console.log('[kroma3d] onViewerReady fired via ' + src); } catch (e) {} }
      try { cb(); } catch (e) {}
    }
    window.addEventListener('message', function (ev) {
      if (!ev || !ev.data || ev.data.type !== 'kroma3d:ready') return;
      try { var host = new URL(ev.origin).hostname; if (host && !/(^|\.)kroma3d\.app$/i.test(host)) return; } catch (e) { return; }
      readySeen = true;
      run('ready');
    });
    if (iframe) iframe.addEventListener('load', function () { setTimeout(function () { if (!readySeen) run('load-fallback'); }, 3000); });
  }

  return {
    mode: MODE, markup: MARKUP,
    mountViewer: mountViewer, mountFullscreen: mountFullscreen, listenSelection: listenSelection,
    onViewerReady: onViewerReady,
    newLamp: newLamp,
    topById: topById, baseById: baseById, capOfBase: capOfBase, priceOfItem: priceOfItem,
    topPrice: topPrice, baseUnitPrice: baseUnitPrice, bodyPrice: bodyPrice,
    powerAdd: powerAdd, bulbAdd: bulbAdd, matteAdd: matteAdd, baseHasLight: baseHasLight, calcLamp: calcLamp,
    lampWeight: lampWeight, lampHeight: lampHeight, deliveryInfo: deliveryInfo,
    encodeConfig: encodeConfig, decodeConfig: decodeConfig,
    lampCount: lampCount, bundleRate: bundleRate, grandSubtotal: grandSubtotal, grandTotal: grandTotal
  };
})();
